"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContrastTheme = void 0;
var useContrastTheme_1 = require("./useContrastTheme");
Object.defineProperty(exports, "useContrastTheme", { enumerable: true, get: function () { return __importDefault(useContrastTheme_1).default; } });
